import styled from 'styled-components';

const YadoItemPhotoView = styled.div`
  min-width: 100px;
  height: 132px;
  position: relative;
  background-color: var(--gray100);
  background-size: cover;
  background-position: center center;
  border-top-left-radius: 0.25em;
  .rating {
    --size: 32px;
    position: absolute;
    top: 0.5em;
    right: 0.5em;
    background-color: #FAA355;
    border-radius: 0.25em 0.25em 0.25em 1em;
    font-size: 0.75em;
    width: var(--size);
    height: var(--size);
    line-height: var(--size);
    text-align: center;
    font-weight: bold;
    color: var(--gray0);
  }
`;

export default YadoItemPhotoView
